import { useState } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { Link, useLocation } from "react-router-dom";
import LoginButton from "../Components/Login/LoginButton.js";
import LogoutButton from "../Components/Login/LogoutButton.js";
import RegisterButton from "../Components/Login/RegisterButton.js";
import ProfileButton from "../Components/Profile/ProfileButton.js";

// On mobile the primary nav destinations (Home, Competitions, Teams, Transfers)
// are handled by BottomNav. This drawer exposes auth actions and admin links only.
const NavigationDrawer = (props) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <div data-testid="navigationDrawer">
      {/* onClose enables backdrop-click and Escape key to close the drawer */}
      <Drawer open={open} onClose={() => setOpen(false)}>
        <List>
          {!props.showActions && (
            <ListItemButton key={1} divider>
              <ListItemIcon>
                <LoginButton></LoginButton>
              </ListItemIcon>
            </ListItemButton>
          )}
          {!props.showActions && (
            <ListItemButton key={2} divider>
              <ListItemIcon>
                <RegisterButton></RegisterButton>
              </ListItemIcon>
            </ListItemButton>
          )}
          {props.showActions && (
            <ListItemButton key={3} divider>
              <ListItemIcon>
                <ProfileButton></ProfileButton>
              </ListItemIcon>
            </ListItemButton>
          )}
          {props.showActions && (
            <ListItemButton
              key={4}
              divider
              selected={location.pathname.startsWith("/user")}
              onClick={() => setOpen(false)}
              component={Link}
              to="/users"
            >
              <ListItemIcon>
                <ListItemText sx={{ color: "white" }}>Users</ListItemText>
              </ListItemIcon>
            </ListItemButton>
          )}
          {props.showActions && (
            <ListItemButton
              key={5}
              divider
              selected={location.pathname === "/admin"}
              onClick={() => setOpen(false)}
              component={Link}
              to="/admin"
            >
              <ListItemIcon>
                <ListItemText sx={{ color: "white" }}>Admin</ListItemText>
              </ListItemIcon>
            </ListItemButton>
          )}
          {props.showActions && (
            <ListItemButton key={6} divider>
              <ListItemIcon>
                <LogoutButton></LogoutButton>
              </ListItemIcon>
            </ListItemButton>
          )}
          <ListItemButton
            key={7}
            divider
            selected={location.pathname === "/about"}
            onClick={() => setOpen(false)}
            component={Link}
            to="/about"
          >
            <ListItemIcon>
              <ListItemText sx={{ color: "white" }}>About</ListItemText>
            </ListItemIcon>
          </ListItemButton>
          <ListItemButton
            key={8}
            divider
            selected={location.pathname === "/updates"}
            onClick={() => setOpen(false)}
            component={Link}
            to="/updates"
          >
            <ListItemIcon>
              <ListItemText sx={{ color: "white" }}>Site Updates</ListItemText>
            </ListItemIcon>
          </ListItemButton>
        </List>
      </Drawer>

      <IconButton
        data-testid="navigationDrawerIcon"
        sx={{ marginLeft: "auto", color: "white" }}
        onClick={() => setOpen(!open)}
      >
        <MenuRoundedIcon></MenuRoundedIcon>
      </IconButton>
    </div>
  );
};

export default NavigationDrawer;
